import React, { Component } from "react";
import { Redirect, Link } from "react-router-dom";
import { Modal, notification, Icon, Button, DatePicker, Tooltip } from "antd";
import DrawerAdicionar from "./Drawers/DrawerAdicionar";
import { Calendar, momentLocalizer } from "react-big-calendar";
import { GlobalContext } from "../../app/providers/GlobalState";
import { GeralContext } from "../ContextProvider";
import axios from "axios";
import moment from "moment";

import ModalDetalhe from "./Modals/Detalhe/Detalhe";
import ModalLoading from "../../shared/components/Modals/ModalLoading";
import ModalViewer from "../../shared/components/Modals/ModalViewer";

import Acessos from "../../Geral/Acessos/Acessos";

import { getLabel } from "../../shared/utils/labelConfig";

import "react-big-calendar/lib/css/react-big-calendar.css";

const localizer = momentLocalizer(moment);

const { MonthPicker, WeekPicker } = DatePicker;

const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

const blockedRules = {
    0: null, // Domingo — tudo bloqueado
    1: { start: 6, end: 23 }, // Segunda
    2: { start: 6, end: 23 }, // Terça
    3: { start: 6, end: 23 }, // Quarta
    4: { start: 6, end: 23 }, // Quinta
    5: { start: 6, end: 23 }, // Sexta
    6: { start: 6, end: 23 } // Sábado
};

class AtendimentosTurma extends Component {
    static contextType = GlobalContext;

    state = {
        dataCalendario: new Date(),
        vista: "week",
        inicio: moment().startOf("week").format("YYYY/MM/DD"),
        termino: moment().endOf("week").format("YYYY/MM/DD"),
        horaInicioCalendario: undefined,
        horaInicioCalendario: undefined,
        dataHoraInicio: "",
        periodosTooltip: "",
        atendimentos: [],
        ultimaCor: "",
        //LOADING
        iconLoading: false,
        //DRAWER ADICIONAR
        visible: false,
        //DRAWER DETALHE
        modalEventoVisible: false,
        aulaId: "",
        titulo: "",
        mesmoDia: false,
        data: "",
        horas: "",
        descricao: "",
        autor: false,
        cursoId: "",
        moduloIndex: "",
        tarefaId: "",
        stepmeet: "",
        tipo: "",
        link: "",
        botaoAtivo: false,
        registarUrl: "",
        aluno: false,
        tipoBotao: {},
        externa: false,
        convite: "",
        //REDIRECT
        redirect: false,
        redirectLink: "",
        //MODAL DETALHE
        visibleModalDetalhe: false,
        //FILTRO
        filtroEscolaId: null,
        info: "",
        //MODAL EXPORT
        visibleExport: false,
        buttonDownload: false,
        exportFile: "",
        empresaId: localStorage.getItem("entidade_id"),
        //DOCS
        docs: [],
        visibleLoading: false,
        modalVisible: false
    };

    UNSAFE_componentWillMount() {
        if (
            localStorage.getItem("posicao_calendario") &&
            localStorage.getItem("temp_codigo_curso") === localStorage.getItem("codigo_curso")
        ) {
            const data = new Date(localStorage.getItem("posicao_calendario"));
            let vista = localStorage.getItem("vista_calendario");

            if (vista === null) {
                localStorage.setItem("vista_calendario", "week");
                vista = "week";
            }

            this.setState(
                {
                    dataCalendario: data,
                    vista,
                    inicio: moment(data).startOf(vista).isoWeekday(0).format("YYYY/MM/DD"),
                    termino: moment(data).endOf(vista).isoWeekday(6).format("YYYY/MM/DD")
                },
                () => this.listar()
            );
        } else {
            localStorage.setItem("posicao_calendario", this.state.dataCalendario);
            localStorage.setItem("vista_calendario", this.state.vista);
            localStorage.setItem("temp_codigo_curso", localStorage.getItem("codigo_curso"));
            this.listar();
        }

        this.periodoBimestre();
    }

    selecionarOpcaoHandler = event => {
        this.setState({
            opcao: event.target.value
        });
    };

    componentDidUpdate() {
        const { estabelecimento } = this.context;
        const { filtroEscolaId } = this.state;

        if (estabelecimento?.id && estabelecimento.id !== filtroEscolaId) {
            this.setState({
                filtroEscolaId: estabelecimento.id
            });
        }
    }

    atualizarPosicaoCalendário = dataCalendario => {
        localStorage.setItem("posicao_calendario", dataCalendario);
        const vista = localStorage.getItem("vista_calendario");
        this.setState(
            {
                dataCalendario,
                vista,
                inicio: moment(dataCalendario).startOf(vista).format("YYYY/MM/DD"),
                termino: moment(dataCalendario).endOf(vista).format("YYYY/MM/DD")
            },
            () => {
                this.listar();
                this.periodoBimestre();
            }
        );
    };

    handleSelectSlot = slotInfo => {
        const start = slotInfo.start;

        const rule = blockedRules[start.getDay()];
        const hour = start.getHours();

        if (!rule || hour < rule.start || hour >= rule.end) {
            return;
        }

        if (this.state.vista === "month") return;
        this.setState({
            dataHoraInicio: start,
            visible: true
        });
    };

    openMonthPicker = () => {
        this.setState({ monthPickerOpen: true });
    };

    closeMonthPicker = () => {
        this.setState({ monthPickerOpen: false });
    };

    handleMonthChange = value => {
        if (!value) {
            this.closeMonthPicker();
            return;
        }

        moment.updateLocale("pt", { week: { dow: 0 } });

        const date = value.clone();

        let inicio;
        let termino;

        if (this.state.vista === "month") {
            inicio = date.clone().startOf("month").startOf("week");
            termino = date.clone().endOf("month").endOf("week");
        } else {
            inicio = date.clone().startOf("week");
            termino = date.clone().endOf("week");
        }

        const dataCalendario = date.toDate();

        this.setState(
            {
                dataCalendario,
                inicio: inicio.format("YYYY/MM/DD"),
                termino: termino.format("YYYY/MM/DD"),
                monthPickerOpen: false
            },
            () => {
                this.listar();
                this.periodoBimestre();
            }
        );
    };

    periodoBimestre = () => {
        this.setState(
            {
                iconLoading: true
            },
            () => {
                axios({
                    method: "get",
                    url: "/api/aulas/total-periodos-diario",
                    params: {
                        cursoId: localStorage.getItem("codigo_curso"),
                        inicio: this.state.inicio,
                        termino: this.state.termino
                    }
                })
                    .then(response => {
                        const { periodos, tooltip } = response.data;

                        this.setState({
                            periodos,
                            periodosTooltip: tooltip !== "" ? tooltip : "Fora do período letivo",
                            iconLoading: false
                        });
                    })
                    .catch(error => {
                        this.setState({
                            iconLoading: false
                        });
                    });
            }
        );
    };

    listar = () => {
        this.setState(
            {
                iconLoading: true
            },
            () => {
                axios({
                    method: "get",
                    url: "/api/atendimento/carregar-atendimentos",
                    params: {
                        id: localStorage.getItem("codigo_curso"),
                        inicio: this.state.inicio,
                        termino: this.state.termino
                    }
                })
                    .then(response => {
                        const atendimentosOrdenados = response.data.slice().sort((a, b) => new Date(a.inicio) - new Date(b.inicio));

                        const primeiroRegisto = atendimentosOrdenados.shift();
                        const horaPrimeiroRegisto = primeiroRegisto ? new Date(primeiroRegisto.inicio) : null;

                        if (horaPrimeiroRegisto != null) horaPrimeiroRegisto.setHours(horaPrimeiroRegisto.getHours() - 6);

                        const atendimentos = response.data.map(aula => {
                            return {
                                id: aula.id,
                                title: aula.titulo,
                                start: new Date(aula.inicio),
                                end: new Date(aula.termino),
                                cor: aula.cor,
                                titulo: aula.titulo,
                                data: aula.data,
                                horaInicio: aula.horaInicio,
                                horaFim: aula.horaFim,
                                disciplina: aula.disciplina
                            };
                        });

                        this.setState({
                            atendimentos,
                            horaInicioCalendario: horaPrimeiroRegisto,
                            iconLoading: false
                        });
                    })
                    .catch(error => {
                        if (error.response.status === 401)
                            this.setState({
                                redirect: true,
                                redirectLink: "/login"
                            });
                        else {
                            openNotificationWithIcon(
                                "error",
                                "Erro",
                                error.response.data || "Ocorreu um erro ao carregar os atendimentos."
                            );
                        }
                    })
                    .finally(() => {
                        this.setState({
                            iconLoading: false
                        });
                    });
            }
        );
    };

    gerarHorario = () => {
        this.setState({
            visibleLoading: true
        });

        if (localStorage.getItem("vista_calendario") === "month")
            axios({
                method: "get",
                url: "/api/pdf/calendario-mes",
                params: {
                    cursoId: localStorage.getItem("codigo_curso"),
                    inicio: this.state.dataCalendario
                }
            })
                .then(response => {
                    this.setState({
                        docs: [{ uri: response.data }],
                        visibleLoading: false,
                        modalVisible: true
                    });
                })
                .catch(() => {
                    openNotificationWithIcon("error", "Erro", "Não foi possível gerar documento!");
                    this.setState({
                        visibleLoading: false
                    });
                });
        else
            axios({
                method: "get",
                url: "/api/pdf/horarios-atendimento",
                params: {
                    turmaId: localStorage.getItem("codigo_curso"),
                    inicio: this.state.inicio,
                    termino: this.state.termino
                }
            })
                .then(response => {
                    this.setState({
                        docs: [{ uri: response.data }],
                        visibleLoading: false,
                        modalVisible: true
                    });
                })
                .catch(() => {
                    openNotificationWithIcon("error", "Erro", "Não foi possível gerar documento!");
                    this.setState({
                        visibleLoading: false
                    });
                });
    };

    listarOndeExistem = (toolbar, tipo) => {
        this.setState(
            {
                iconLoading: true
            },
            () => {
                axios({
                    method: "get",
                    url: "/api/aulas/listar-onde-existem",
                    params: {
                        cursoId: localStorage.getItem("codigo_curso"),
                        inicio: this.state.inicio,
                        termino: this.state.termino,
                        vista: toolbar.view,
                        tipo
                    }
                })
                    .then(response => {
                        if (response.data === "ANTERIOR" || response.data === "PROXIMO") {
                            openNotificationWithIcon(
                                "warning",
                                "Atenção",
                                response.data === "ANTERIOR" ? "Não existem anteriores" : "Não existem próximas aulas"
                            );
                            this.setState({
                                iconLoading: false
                            });
                        } else {
                            var count = response.data;

                            if (tipo === "ANTERIOR") {
                                if (toolbar.view === "month") {
                                    toolbar.date.setMonth(toolbar.date.getMonth() - count * 1);
                                    toolbar.onNavigate("prev");
                                    this.setState(
                                        {
                                            dataCalendario: toolbar.date
                                        },
                                        () => localStorage.setItem("posicao_calendario", this.state.dataCalendario)
                                    );
                                } else if (toolbar.view === "week") {
                                    let mDate = this.state.dataCalendario;
                                    let newDate = new Date(mDate.getFullYear(), mDate.getMonth(), mDate.getDate() - count * 7);
                                    toolbar.onNavigate("prev", newDate);
                                    this.setState(
                                        {
                                            dataCalendario: newDate
                                        },
                                        () => localStorage.setItem("posicao_calendario", this.state.dataCalendario)
                                    );
                                } else {
                                    let mDate = this.state.dataCalendario;
                                    let newDate = new Date(mDate.getFullYear(), mDate.getMonth(), mDate.getDate() - count);
                                    toolbar.onNavigate("prev", newDate);
                                    this.setState(
                                        {
                                            dataCalendario: newDate
                                        },
                                        () => localStorage.setItem("posicao_calendario", this.state.dataCalendario)
                                    );
                                }
                            } else {
                                if (toolbar.view === "month") {
                                    toolbar.date.setMonth(toolbar.date.getMonth() + count * 1);
                                    toolbar.onNavigate("next");
                                    this.setState(
                                        {
                                            dataCalendario: toolbar.date
                                        },
                                        () => localStorage.setItem("posicao_calendario", this.state.dataCalendario)
                                    );
                                } else if (toolbar.view === "week") {
                                    let mDate = this.state.dataCalendario;
                                    let newDate = new Date(mDate.getFullYear(), mDate.getMonth(), mDate.getDate() + count * 7);
                                    toolbar.onNavigate("prev", newDate);
                                    this.setState(
                                        {
                                            dataCalendario: newDate
                                        },
                                        () => localStorage.setItem("posicao_calendario", this.state.dataCalendario)
                                    );
                                } else {
                                    try {
                                        let mDate = this.state.dataCalendario;
                                        let newDate = new Date(mDate.getFullYear(), mDate.getMonth(), mDate.getDate() + count);
                                        toolbar.onNavigate("prev", newDate);
                                        this.setState(
                                            {
                                                dataCalendario: newDate
                                            },
                                            () => localStorage.setItem("posicao_calendario", this.state.dataCalendario)
                                        );
                                    } catch (error) {}
                                }
                            }
                        }
                    })
                    .catch(error => {
                        if (error.response.status === 401)
                            this.setState({
                                redirect: true,
                                redirectLink: "/login"
                            });

                        this.setState({
                            iconLoading: false
                        });
                    });
            }
        );
    };

    onRangeChange = range => {
        if (range.length) {
            this.setState(
                {
                    inicio: moment(range[0]).format("YYYY/MM/DD"),
                    termino: moment(range.pop()).format("YYYY/MM/DD")
                },
                () => {
                    this.listar();
                    this.periodoBimestre();
                }
            );
        } else {
            this.setState(
                {
                    inicio: moment(range.start).format("YYYY/MM/DD"),
                    termino: moment(range.end).format("YYYY/MM/DD")
                },
                () => {
                    this.listar();
                    this.periodoBimestre();
                }
            );
        }
    };

    onDrillDown = range => {
        this.setState(
            {
                inicio: moment(range).format("YYYY/MM/DD"),
                termino: moment(range).format("YYYY/MM/DD"),
                vista: "day",
                dataCalendario: range
            },
            () => {
                localStorage.setItem("posicao_calendario", this.state.dataCalendario);
                localStorage.setItem("vista_calendario", "day");
            }
        );
    };

    getMonthNameInPortuguese(date) {
        const monthIndex = date.month();
        const monthNames = [
            "janeiro",
            "fevereiro",
            "março",
            "abril",
            "maio",
            "junho",
            "julho",
            "agosto",
            "setembro",
            "outubro",
            "novembro",
            "dezembro"
        ];
        return monthNames[monthIndex];
    }

    getDayOfWeekInPortuguese(date) {
        const dayIndex = date.day();
        const dayNames = ["Domingo", "Segunda-feira", "Terça-feira", "Quarta-feira", "Quinta-feira", "Sexta-feira", "Sábado"];
        return dayNames[dayIndex];
    }

    onSelectEvent = event => {
        const acesso = this.context.acessos?.find(x => x.func === 17);

        if (acesso?.read) {
            localStorage.setItem("atendimento", event.id);
            localStorage.setItem("link_voltar_calendario", this.props.match.url);
            localStorage.setItem("horario_detalhe_titulo", !event.titulo ? event.disciplina : event.titulo);
            localStorage.setItem(
                "horario_detalhe_data_hora",
                `(${moment(event.data).format("DD/MM/YYYY")} - ${event.horaInicio} às ${event.horaFim})`
            );
            this.setState({
                redirect: true,
                redirectLink: `/gerir-detalhe-turma/${this.props.match.params.turma}/atendimento-detalhe`
            });
        }
    };

    editarEvento = () => {
        this.setState({
            modalEventoVisible: false,
            visible: true
        });
    };

    montarBotaoVoltar = () => {
        if (localStorage.getItem("opcao_voltar") != null) {
            const opcaoInfo = JSON.parse(localStorage.getItem("opcao_voltar"));
            return (
                <Link
                    to={opcaoInfo.link_voltar_curso ? opcaoInfo.link_voltar_curso : opcaoInfo.link_voltar}
                    className="botao-secundario botao-secundario-redondo"
                    onClick={() => opcaoInfo.id_curso && localStorage.setItem("codigo_curso", opcaoInfo.id_curso)}
                    style={{ marginRight: 10, display: "flex", justifyContent: "center", alignItems: "center" }}
                >
                    <Icon type="arrow-left" />
                </Link>
            );
        }
    };

    render() {
        const {
            dataCalendario,
            vista,
            atendimentos,
            horaInicioCalendario,
            periodosTooltip,
            //DRAWER ADICIONAR
            visible,
            dataHoraInicio,
            //MODAL DETALHE
            aulaId,
            //REDIRECT
            redirect,
            redirectLink,
            //LOADING
            iconLoading,
            //MODAL DETALHE
            visibleModalDetalhe,
            info,
            //DOCS
            docs,
            visibleLoading,
            modalVisible
        } = this.state;

        if (redirect) return <Redirect to={redirectLink} />;

        const eventStyleGetter = (event, start, end, isSelected) => {
            const style = {
                background: event.avaliacao
                    ? `linear-gradient(145deg, rgba(255,166,0,1) 0%, rgba(255,166,0,1) 15%, ${event.cor} 15%)`
                    : event.cor
            };
            return {
                style: style
            };
        };

        const slotPropGetter = date => {
            const rule = blockedRules[date.getDay()];
            const hour = date.getHours();

            // Domingo — tudo bloqueado
            if (!rule) {
                return { className: "rbc-blocked-slot" };
            }

            // Fora do intervalo permitido
            if (hour < rule.start || hour >= rule.end) {
                return { className: "rbc-blocked-slot" };
            }

            return {};
        };

        const toolbar = toolbar => {
            const anterior = () => {
                if (toolbar.view === "month") {
                    toolbar.date.setMonth(toolbar.date.getMonth() - 1);
                    toolbar.onNavigate("prev");
                    this.setState(
                        {
                            dataCalendario: toolbar.date
                        },
                        () => localStorage.setItem("posicao_calendario", this.state.dataCalendario)
                    );
                } else if (toolbar.view === "week") {
                    let mDate = this.state.dataCalendario;
                    let newDate = new Date(mDate.getFullYear(), mDate.getMonth(), mDate.getDate() - 7);
                    toolbar.onNavigate("prev", newDate);
                    this.setState(
                        {
                            dataCalendario: newDate
                        },
                        () => localStorage.setItem("posicao_calendario", this.state.dataCalendario)
                    );
                } else {
                    let mDate = this.state.dataCalendario;
                    let newDate = new Date(mDate.getFullYear(), mDate.getMonth(), mDate.getDate() - 1);
                    toolbar.onNavigate("prev", newDate);
                    this.setState(
                        {
                            dataCalendario: newDate
                        },
                        () => localStorage.setItem("posicao_calendario", this.state.dataCalendario)
                    );
                }
            };

            const proximo = () => {
                if (toolbar.view === "month") {
                    toolbar.date.setMonth(toolbar.date.getMonth() + 1);
                    toolbar.onNavigate("next");
                    this.setState(
                        {
                            dataCalendario: toolbar.date
                        },
                        () => localStorage.setItem("posicao_calendario", this.state.dataCalendario)
                    );
                } else if (toolbar.view === "week") {
                    let mDate = this.state.dataCalendario;
                    let newDate = new Date(mDate.getFullYear(), mDate.getMonth(), mDate.getDate() + 7);
                    toolbar.onNavigate("prev", newDate);
                    this.setState(
                        {
                            dataCalendario: newDate
                        },
                        () => localStorage.setItem("posicao_calendario", this.state.dataCalendario)
                    );
                } else {
                    let mDate = this.state.dataCalendario;
                    let newDate = new Date(mDate.getFullYear(), mDate.getMonth(), mDate.getDate() + 1);
                    toolbar.onNavigate("prev", newDate);
                    this.setState(
                        {
                            dataCalendario: newDate
                        },
                        () => localStorage.setItem("posicao_calendario", this.state.dataCalendario)
                    );
                }
            };

            const labelData = () => {
                const date = moment(toolbar.date);
                if (toolbar.view === "month") return <span>{date.format("MMMM YYYY")}</span>;
                else if (toolbar.view === "week") {
                    return <span>{toolbar.label}</span>;
                } else return <span>{date.format("dddd, DD [de] MMMM YYYY")}</span>;
            };

            const vistaMes = () => {
                toolbar.onView("month");
                this.setState(
                    {
                        vista: "month"
                    },
                    () => localStorage.setItem("vista_calendario", "month")
                );
            };

            const vistaSemana = () => {
                toolbar.onView("week");
                this.setState(
                    {
                        vista: "week"
                    },
                    () => localStorage.setItem("vista_calendario", "week")
                );
            };

            const vistaDia = () => {
                toolbar.onView("day");
                this.setState(
                    {
                        vista: "day"
                    },
                    () => localStorage.setItem("vista_calendario", "day")
                );
            };

            const montarTitleSetaEsq = () => {
                if (vista === "month") return "Mês anterior";
                else if (vista === "week") return "Semana anterior";
                else return "Dia anterior";
            };

            const montarTitleSetaDir = () => {
                if (vista === "month") return "Próximo mês";
                else if (vista === "week") return "Próxima semana";
                else return "Próximo dia";
            };

            return (
                <>
                    <div className="toolbar-container toolbar-container-desktop">
                        <div className="toolbal-opcoes-esquerda" style={{ minWidth: "200px" }}>
                            <Button.Group>
                                <Button className="btn-anterior" title={montarTitleSetaEsq()} onClick={anterior}>
                                    <Icon type="left" />
                                </Button>
                                <Button className="btn-proximo" title={montarTitleSetaDir()} onClick={proximo}>
                                    <Icon type="right" />
                                </Button>
                            </Button.Group>
                        </div>
                        <div className="toolbal-label-data">
                            <Tooltip placement="right" title={periodosTooltip}>
                                <label
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        gap: "5px",
                                        cursor: "pointer",
                                        border: "1px solid #d9d9d9",
                                        borderRadius: "4px",
                                        padding: "0px 15px",
                                        boxShadow: "0 2px 0 rgba(0, 0, 0, 0.015)",
                                        marginBottom: 0,
                                        height: "32px",
                                        fontSize: "14px",
                                        fontWeight: "normal"
                                    }}
                                    onClick={this.openMonthPicker}
                                    className="label-data"
                                >
                                    {labelData()} {this.state.monthPickerOpen ? <Icon type="caret-up" /> : <Icon type="caret-down" />}
                                </label>
                            </Tooltip>

                            {vista === "month" && (
                                <MonthPicker
                                    open={this.state.monthPickerOpen}
                                    value={dataCalendario ? moment(dataCalendario) : null}
                                    onOpenChange={open => this.setState({ monthPickerOpen: open })}
                                    onChange={this.handleMonthChange}
                                    style={{
                                        position: "absolute",
                                        opacity: 0,
                                        width: 0,
                                        height: 0,
                                        padding: 0,
                                        margin: 0,
                                        pointerEvents: "none"
                                    }}
                                    getCalendarContainer={() => document.body}
                                />
                            )}

                            {vista === "week" && (
                                <WeekPicker
                                    open={this.state.monthPickerOpen}
                                    value={dataCalendario ? moment(dataCalendario) : null}
                                    onOpenChange={open => this.setState({ monthPickerOpen: open })}
                                    onChange={this.handleMonthChange}
                                    style={{
                                        position: "absolute",
                                        opacity: 0,
                                        width: 0,
                                        height: 0,
                                        padding: 0,
                                        margin: 0,
                                        pointerEvents: "none"
                                    }}
                                    getCalendarContainer={() => document.body}
                                />
                            )}
                        </div>
                        <div className="toolbal-opcoes-direita" style={{ minWidth: "200px", textAlign: "right" }}>
                            <Button.Group>
                                <Button className={`btn-mes ${vista === "month" ? " ativa" : ""}`} onClick={vistaMes}>
                                    Mês
                                </Button>
                                <Button className={`btn-semana ${vista === "week" ? " ativa" : ""}`} onClick={vistaSemana}>
                                    Semana
                                </Button>
                            </Button.Group>
                        </div>
                    </div>
                    <div className="toolbar-container toolbar-container-tablet">
                        <div className="toolbal-opcoes-cima">
                            <Button.Group>
                                <Button.Group>
                                    <Button className="btn-anterior" title={montarTitleSetaEsq()} onClick={anterior}>
                                        <Icon type="left" />
                                    </Button>
                                    <Button className="btn-proximo" title={montarTitleSetaDir()} onClick={proximo}>
                                        <Icon type="right" />
                                    </Button>
                                </Button.Group>
                            </Button.Group>
                            <Button.Group>
                                <Button className={`btn-mes ${vista === "month" ? " ativa" : ""}`} onClick={vistaMes}>
                                    Mês
                                </Button>
                                <Button className={`btn-semana ${vista === "week" ? " ativa" : ""}`} onClick={vistaSemana}>
                                    Semana
                                </Button>
                            </Button.Group>
                        </div>
                        <div className="toolbal-opcoes-baixo">
                            <div className="toolbal-label-data">
                                <Tooltip placement="right" title={periodosTooltip}>
                                    <label
                                        style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            gap: "5px",
                                            cursor: "pointer",
                                            border: "1px solid #d9d9d9",
                                            borderRadius: "4px",
                                            padding: "0px 15px",
                                            boxShadow: "0 2px 0 rgba(0, 0, 0, 0.015)",
                                            marginBottom: 0,
                                            height: "32px",
                                            fontSize: "14px",
                                            fontWeight: "normal"
                                        }}
                                        onClick={this.openMonthPicker}
                                        className="label-data"
                                    >
                                        {labelData()} {this.state.monthPickerOpen ? <Icon type="caret-up" /> : <Icon type="caret-down" />}
                                    </label>
                                </Tooltip>
                            </div>
                        </div>
                    </div>
                    <div className="toolbar-container toolbar-container-mobile">
                        <div className="toolbal-opcoes-esquerda">
                            <Button.Group>
                                <Button.Group>
                                    <Button className="btn-anterior" title={montarTitleSetaEsq()} onClick={anterior}>
                                        <Icon type="left" />
                                    </Button>
                                    <Button className="btn-proximo" title={montarTitleSetaDir()} onClick={proximo}>
                                        <Icon type="right" />
                                    </Button>
                                </Button.Group>
                            </Button.Group>
                        </div>
                        <div className="toolbal-opcoes-direita">
                            <Button.Group>
                                <Button className={`btn-mes ${vista === "month" ? " ativa" : ""}`} onClick={vistaMes}>
                                    Mês
                                </Button>
                                <Button className={`btn-dia ${vista === "day" ? " ativa" : ""}`} onClick={vistaDia}>
                                    Dia
                                </Button>
                            </Button.Group>
                        </div>
                        <div className="toolbal-label-data">
                            <Tooltip placement="right" title={periodosTooltip}>
                                <label
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        gap: "5px",
                                        cursor: "pointer",
                                        border: "1px solid #d9d9d9",
                                        borderRadius: "4px",
                                        padding: "0px 15px",
                                        boxShadow: "0 2px 0 rgba(0, 0, 0, 0.015)",
                                        marginBottom: 0,
                                        height: "32px",
                                        fontSize: "14px",
                                        fontWeight: "normal"
                                    }}
                                    onClick={this.openMonthPicker}
                                    className="label-data"
                                >
                                    {labelData()} {this.state.monthPickerOpen ? <Icon type="caret-up" /> : <Icon type="caret-down" />}
                                </label>
                            </Tooltip>
                        </div>
                    </div>
                </>
            );
        };

        const hoje = new Date();

        moment.updateLocale("pt", {
            week: {
                dow: 0
            }
        });

        const min = new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate(), 5, 0);
        let max = new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate(), 19, 0);

        if (localStorage.getItem("header_codigo")?.includes("EJA"))
            max = new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate(), 23, 59);

        const acesso = this.context.acessos?.find(x => x.func === 14);

        const canalId = parseInt(localStorage.getItem("entidade_id"));

        const labelRelatorios = getLabel("ensinoEspecialRelatorios", { canalId });

        return (
            <>
                <Acessos funcionalidadeId={14} />
                <div className="container container-body bloco-diario">
                    <div className="turma-visao-geral hidden">
                        <div className="desktop">
                            <div className="controlos controlos-fundo">
                                <div className="bloco-esquerda">
                                    {acesso?.create && (
                                        <Link
                                            to="#"
                                            className="botao-principal botao-principal-redondo"
                                            title="Nova aula"
                                            onClick={() =>
                                                this.setState({
                                                    visible: true,
                                                    aulaId: ""
                                                })
                                            }
                                        >
                                            +
                                        </Link>
                                    )}
                                </div>
                                <div className="bloco-direita">
                                    <Link
                                        className="botao-icon-conteudo "
                                        to={`/gerir-detalhe-turma/${this.props.match.params.turma}/relatorios-atendimento`}
                                        title="Conteúdos"
                                        onClick={() => localStorage.setItem("vista", "TURMA")}
                                    >
                                        <Icon type="read" />
                                        {labelRelatorios}
                                    </Link>
                                    <Link className="botao-icon-detalhe-diario " to="#" title="Descarregar PDF" onClick={this.gerarHorario}>
                                        <Icon type="eye" />
                                        Horário
                                    </Link>

                                    {this.montarBotaoVoltar()}
                                </div>
                            </div>
                        </div>

                        <div className="mobile">
                            <div className="controlos controlos-fundo">
                                <div className="bloco-esquerda" style={{ justifyContent: "space-between" }}>
                                    {acesso?.create && (
                                        <Link
                                            to="#"
                                            className="botao-principal botao-principal-redondo"
                                            title="Nova aula"
                                            onClick={() =>
                                                this.setState({
                                                    visible: true,
                                                    aulaId: ""
                                                })
                                            }
                                        >
                                            +
                                        </Link>
                                    )}
                                    {this.montarBotaoVoltar()}
                                </div>
                                <div className="bloco-direita">
                                    <Link
                                        className="botao-icon-conteudo "
                                        to={`/gerir-detalhe-turma/${this.props.match.params.turma}/relatorios-atendimento`}
                                        title="Conteúdos"
                                        onClick={() => localStorage.setItem("vista", "TURMA")}
                                    >
                                        <Icon type="read" />
                                        {labelRelatorios}
                                    </Link>
                                    <Link className="botao-icon-detalhe-diario " to="#" title="Descarregar PDF" onClick={this.gerarHorario}>
                                        <Icon type="eye" />
                                        Horário
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="curso-diario">
                        <Calendar
                            localizer={localizer}
                            events={atendimentos}
                            min={min}
                            max={max}
                            scrollToTime={
                                new Date(
                                    hoje.getFullYear(),
                                    hoje.getMonth(),
                                    hoje.getDate(),
                                    horaInicioCalendario?.getHours(),
                                    horaInicioCalendario?.getMinutes()
                                )
                            }
                            startAccessor="start"
                            endAccessor="end"
                            style={{ height: 700 }}
                            defaultView={vista}
                            view={vista}
                            date={dataCalendario}
                            views={["month", "week", "day"]}
                            components={{
                                toolbar: toolbar
                            }}
                            onView={() => {}}
                            onNavigate={() => {}}
                            onSelectEvent={this.onSelectEvent}
                            onDrillDown={this.onDrillDown}
                            onRangeChange={this.onRangeChange}
                            eventPropGetter={eventStyleGetter}
                            selectable={true}
                            onSelecting={() => false}
                            onSelectSlot={this.handleSelectSlot}
                            slotPropGetter={slotPropGetter}
                        />
                    </div>
                </div>
                <DrawerAdicionar
                    aulaId={aulaId}
                    visible={visible}
                    onClose={() =>
                        this.setState({
                            visible: false
                        })
                    }
                    dataHoraInicio={dataHoraInicio}
                    adicionarAula={evento => this.setState({ atendimentos: [...atendimentos, evento], visible: false })}
                    adicionarAulas={eventos => this.setState({ atendimentos: [...atendimentos, ...eventos], visible: false })}
                    atualizarAula={evento =>
                        this.setState({
                            atendimentos: [...atendimentos.filter(x => x.id !== aulaId), evento],
                            visible: false
                        })
                    }
                    atualizarPosicaoCalendário={dataCalendario => this.atualizarPosicaoCalendário(dataCalendario)}
                    filtroEscolaId={this.state.filtroEscolaId}
                    atualizarListagem={() => {
                        this.setState({ visible: false });
                        this.listar();
                        this.periodoBimestre();
                    }}
                />
                <Modal visible={iconLoading} maskClosable={false} className="modal-loading" footer={null} closable={false}>
                    <div className="modal-loading-bloco">
                        <p>
                            <Icon type="loading" />
                        </p>
                        <p className="texto">A carregar...</p>
                    </div>
                </Modal>
                <ModalDetalhe
                    info={info}
                    visible={visibleModalDetalhe}
                    abrirEditar={() => this.setState({ visible: true, visibleModalDetalhe: false })}
                    onClose={() => this.setState({ visibleModalDetalhe: false })}
                    atualizarListagem={() => this.listar()}
                />
                <ModalLoading visible={visibleLoading} text="A gerar documento..." />
                <ModalViewer visible={modalVisible} docs={docs} onCancel={() => this.setState({ modalVisible: false })} />
            </>
        );
    }
}

const ContextGerirHorario = ({ match }) => (
    <GeralContext.Consumer>
        {({ pareceresPorAula, existeProfTitular, temPermissao }) => (
            <AtendimentosTurma
                pareceresPorAula={pareceresPorAula}
                existeProfTitular={existeProfTitular}
                temPermissao={temPermissao}
                match={match}
            />
        )}
    </GeralContext.Consumer>
);

export default ContextGerirHorario;
